<template>
  <div v-if="showFeature">
    <slot></slot>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { useFeatureFlag, Features } from '@/services/featureflag.service';

export default defineComponent({
  name: 'FeatureWrapper',
  components: {},
  props: {
    feature: {
      type: String as PropType<Features>,
      default: '',
    },
  },
  setup(props) {
    const showFeature = useFeatureFlag(props.feature);

    return {
      showFeature,
    };
  },
});
</script>
